import {Injectable,Inject} from "@angular/core";
/**
 * Eventually will handle JWT authentication tokens, but for now it simply wraps around
 * a shared token.
 */
@Injectable()
export class Authenticator {
    
    constructor(
        @Inject("AuthToken") private _token:string
    ) {}
    
    public get AuthenticationToken() {
        return this._token;
    }
    
    public set AuthenticationToken(v:string) {
        this._token = v;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/authenticator.ts